import { render } from "./MembersOtpView.vue?vue&type=template&id=627815d3"
import script from "./MembersOtpView.vue?vue&type=script&lang=js"
export * from "./MembersOtpView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\luke\\Desktop\\membership_application\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__